/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'shared';
const componentName = 'rbac-label-grid';
const prefix = `${moduleName}.${componentName}`;

export const header = `${prefix}.header`;
export const addButtonLabel = `${prefix}.addButtonLabel`;
export const keyFieldPlaceholder = `${prefix}.keyFieldPlaceholder`;
export const valuesFieldPlaceholder = `${prefix}.valuesFieldPlaceholder`;
export const keyDuplicationErrorMsg = `${prefix}.keyDuplicationErrorMsg`;
export const duplicateValuesErrorMsg = `${prefix}.duplicateValuesErrorMsg`;
export const keyColumnLabel = `${prefix}.keyColumnLabel`;
export const valuesColumnLabel = `${prefix}.valuesColumnLabel`;
export const removeButtonLabel = `${prefix}.removeBtnLabel`;

export const ENGLISH = {
    [header]: 'RBAC Key & Value',
    [addButtonLabel]: 'Add',
    [keyFieldPlaceholder]: 'Enter Key',
    [valuesFieldPlaceholder]: 'Enter Values',
    [keyDuplicationErrorMsg]: 'System does not support duplicate Keys. Please update or delete.',
    [duplicateValuesErrorMsg]: 'Duplicate keys: {0}.',
    [keyColumnLabel]: 'Key',
    [valuesColumnLabel]: 'Value(s)',
    [removeButtonLabel]: 'Remove',
};
